import * as types from './actionTypes';

const initialState = {
  salesAgentList: null,
  salesAgentDetails: null,
  salesAgentMerchantList: null,
  createSalesAgentSuccess: false,
  updateSalesAgentSuccess: false,
  statusUpdateSuccess: false,
  salesAgentError: null,
};

export const salesAgentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SALES_AGENT_LIST:
      return {
        ...state,
        salesAgentList: action.payload,
      };
    case types.SET_SALES_AGENT_DETAILS:
      return {
        ...state,
        salesAgentDetails: action.payload,
      };
    case types.CREATE_SALES_AGENT_SUCCESS:
      return {
        ...state,
        createSalesAgentSuccess: action.payload,
        salesAgentError: null,
      };
    case types.UPDATE_SALES_AGENT_SUCCESS:
      return {
        ...state,
        updateSalesAgentSuccess: action.payload,
        salesAgentError: null,
      };
    case types.CREATE_SALES_AGENT_FAILURE:
    case types.UPDATE_SALES_AGENT_FAILURE:
      return {
        ...state,
        salesAgentError: action.payload,
      };
    case types.CLEAR_SALES_AGENT_ERROR:
      return {
        ...state,
        salesAgentError: null,
      };
    case types.SET_SALES_AGENT_MERCHANTS:
      return {
        ...state,
        salesAgentMerchantList: action.payload,
      };
    case types.CLEAR_SALES_AGENT_VIEW:
      return {
        ...state,
        salesAgentDetails: null,
        salesAgentMerchantList: null,
      };
    case types.UPDATE_SALES_AGENT_STATUS_SUCCESS: {
      // eslint-disable-next-line camelcase -- action payload is in snake_case
      const { id, is_active } = action.payload;
      const salesAgents = state.salesAgentList?.sales_agents || [];
      // eslint-disable-next-line camelcase -- action payload is in snake_case
      const updatedList = salesAgents.map((item) => (item?.id === id ? { ...item, is_active } : item));
      return {
        ...state,
        salesAgentList: {
          ...state.salesAgentList,
          sales_agents: updatedList,
        },
        statusUpdateSuccess: true,
      };
    }
    case types.SET_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: action.payload,
      };
    default:
      return state;
  }
};
